"use client"

import { HeroCarouselSlideDto } from "api"
import {
  PriceBlock,
  PriceCurrency,
  PriceLabel,
  PriceNote,
  PriceValue,
  PriceValueRow,
} from "./hero.styled"
import { hasPriceBlock } from "./heroHelpers"

type Props = { slide: HeroCarouselSlideDto }

const HeroPriceBlock = ({ slide }: Props) => {
  if (!hasPriceBlock(slide)) return null
  return (
    <PriceBlock>
      {slide.priceLabel && <PriceLabel dir="auto">{slide.priceLabel}</PriceLabel>}
      {slide.price && (
        <PriceValueRow>
          <PriceCurrency>₪</PriceCurrency>
          <PriceValue>{slide.price}</PriceValue>
        </PriceValueRow>
      )}
      {slide.priceNote && <PriceNote dir="auto">{slide.priceNote}</PriceNote>}
    </PriceBlock>
  )
}

export default HeroPriceBlock
